export default {
      id: "svg-icon-arrow-right-usage",
      viewBox: "0 0 24.063 48",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/arrow-right.svg
// module id = NLhE
// module chunks = 4